import { createContext, Dispatch, SetStateAction } from "react";
import { Config } from "_core/types";
import * as process from "process";

export type ConfigContextInterface = {
  config: Config | null;
  setConfig: Dispatch<SetStateAction<Config | null>>;
};

const env = process.env.BUILD_ENV as Config["ENVIRONMENT"];

const urlNonprod = "https://nonprod.api.ovoenergy.com/ev-charger-installation";
// todo: replace prod URL with this one once we have verified the proxy behaviour in UAT
// const urlProd = "https://api.ovoenergy.com/ev-charger-installation";
const urlProd = "https://api.evc.ovoenergy.com";

const INITIAL_CONFIG: Config = {
  ENVIRONMENT: env,
  API_URL: env == "prod" ? urlProd : urlNonprod,
};

export const ConfigContext = createContext<ConfigContextInterface>({
  config: INITIAL_CONFIG,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setConfig: () => {},
});
